var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8165 3.69629C14.236 3.86959 15.405 4.89073 15.8027 6.2276M5.22622 3.69629C3.5834 3.89684 2.27628 5.23285 2.11154 6.87965C1.96912 8.30324 1.84277 9.76832 1.84277 11.264C1.84277 12.7597 1.96912 14.2248 2.11154 15.6484C2.27628 17.2952 3.5834 18.6313 5.22622 18.8317C5.82499 18.9049 6.43157 18.9731 7.04503 19.0238",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24414 3.59012C5.24414 4.80343 6.3988 5.71548 7.61023 5.7828C8.073 5.8085 8.54373 5.82674 9.02092 5.82674C9.49811 5.82674 9.96885 5.8085 10.4316 5.7828C11.6431 5.71548 12.7977 4.80343 12.7977 3.59012C12.7977 2.37682 11.6431 1.46476 10.4316 1.39745C9.96885 1.37174 9.49811 1.35352 9.02092 1.35352C8.54373 1.35352 8.073 1.37174 7.61023 1.39745C6.3988 1.46476 5.24414 2.37682 5.24414 3.59012Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4445 19.3268C11.6006 20.9744 12.9148 22.3224 14.5592 22.5092C15.4274 22.608 16.3144 22.6842 17.216 22.6842C18.1175 22.6842 19.0044 22.608 19.8727 22.5092C21.5171 22.3224 22.8312 20.9744 22.9874 19.3268C23.0844 18.3015 23.1624 17.2517 23.1624 16.1829C23.1624 15.1142 23.0844 14.0643 22.9874 13.0391C22.8312 11.3914 21.5171 10.0434 19.8727 9.85657C19.0044 9.75793 18.1175 9.68164 17.216 9.68164C16.3144 9.68164 15.4274 9.75793 14.5592 9.85657C12.9148 10.0434 11.6006 11.3914 11.4445 13.0391C11.3474 14.0643 11.2695 15.1142 11.2695 16.1829C11.2695 17.2517 11.3474 18.3015 11.4445 19.3268Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0141 14.3398H15.4189",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0141 18.3877H15.4189",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.1b03d0c2c5567e71ca4a8ab3910e5d4b.svg";
export { ForwardRef as ReactComponent };